export default __webpack_public_path__ + "static/media/logo.63eabbb7.png";